$(document).ready(function(){
    $('.slider-testimonials').slick({
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    appendArrows: '#slider-arrows-testimonials'
                }
            }
        ]
    })

    $('.slider-tours').slick({

    });

    $('.slider-tours-mobile').slick({
        appendArrows: '#slider-arrows-tours'
    });
    $('.sym-slides').slick({
        arrows: true,
        appendArrows: '#slider-arrows-menu'
    });
    $('.slider-images').slick({
        slidesToShow: 1,
        asNavFor: '.sym-slides-text',
        appendArrows: '#slider-arrows-images',
    });

    $('.gallery-slider__slider').slick({
        accessibility: false,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,        
    });

    $('.slider-home').slick({
        autoplay: true,
        autoplaySpeed: 2000
    });
    $('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        document.querySelector('.counter').setAttribute("style", `width: calc(100% / ${currentSlide + 1})`)
    });
    $('.sym-slides-text').slick({
        speed: 300,
        slidesToShow: 1,
        fade: true,
        adaptiveHeight: true,
        infinite: true,
        arrows: true,
        asNavFor: '.slider-images',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    adaptiveHeight: true,
                }
            },
        ]
    });
    
})

const scrollW = () => {
    //check scroll down or up for header styles
    let st = window.scrollY;
    if (st >= 70) {
        if(document.querySelector('header')) {
            document.querySelector('header').classList.add('down');
            document.querySelector('.come-back').classList.add('down');
            document.querySelector('#content').classList.add('down');
            document.querySelector('.header-container').classList.add('down');
        }
        document.querySelector('.link-bacan').classList.add('down');
    } else {
        if(document.querySelector('header')) {
            document.querySelector('.come-back').classList.remove('down');
            document.querySelector('header').classList.remove('down');
            document.querySelector('#content').classList.remove('down');
            document.querySelector('.header-container').classList.remove('down');
        }
    }
}

// hide tha top bar
const scrollDefault = () => {
    let st = window.scrollY;
    if(!document.body.classList.contains('gallery')){
        if(st >= 12) {
            document.querySelector('header').classList.remove('top-bar');
            document.querySelector('.link-bacan').classList.remove('top-bar');
        }else {
            document.querySelector('header').classList.add('top-bar');
            document.querySelector('.link-bacan').classList.add('top-bar');
        }
    }
}

window.addEventListener('scroll', function () {
    /*if(document.body.classList.contains('home-page')) {
        scrollW();
    }else {
        scrollDefault();
    }*/

    scrollDefault();
})

const showOpentable = () => {
    const containerScript = document.querySelector('.open-table-script');
    /*const bacanLogo = document.querySelector('.link-bacan');*/
    /* if(event.target.getAttribute('id') == 'open-script') {
        bacanLogo.classList.add('hide');
    }else {
        bacanLogo.classList.add('hide');
    } */
    /*bacanLogo.classList.toggle('hide');*/
    containerScript.classList.toggle("active");
}

